module.exports = __webpack_public_path__ + "img/borderInvertedTriangleWhite.dbcf2245.svg";